export const ONBOARDING_MEMBER_FILTER = "onboardingMembers";

const MEMBER_USERS_TAB_STORAGE_KEYS = ["schoolUserManagement.selectedTab", "districtUserManagement.selectedTab"];

/** School Users and District Users are the first tab in User Management. */
export function selectMemberUsersTab(): void {
  try {
    for (const key of MEMBER_USERS_TAB_STORAGE_KEYS) {
      localStorage.setItem(key, "0");
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function userManagementHref(bubbleId: string, filter?: string): string {
  const params = new URLSearchParams({
    adminSelect: bubbleId,
    adminTab: "users",
  });
  if (filter) {
    params.set(ONBOARDING_MEMBER_FILTER, filter);
  }
  return `/admin?${params.toString()}`;
}

export function memberMatchesOnboardingFilter(roles: string[], filter: string | null): boolean {
  if (!filter) {
    return true;
  }
  const has = (role: string) => roles.includes(role);
  switch (filter) {
    case "studentOnly":
      return has("Student") && !has("Candidate");
    case "candidateOnly":
      return has("Candidate") && !has("Student");
    case "both":
      return has("Student") && has("Candidate");
    case "admins":
      return has("Admin");
    case "students":
      return has("Student");
    case "candidateIncomplete":
    case "searchable":
    case "candidates":
      return has("Candidate");
    default:
      return true;
  }
}

export function onboardingMemberFilterNote(filter: string | null): string | null {
  switch (filter) {
    case "studentOnly":
      return "Showing members who are Students and not Candidates.";
    case "candidateOnly":
      return "Showing members who are Candidates and not Students.";
    case "both":
      return "Showing members who are both Students and Candidates.";
    case "admins":
      return "Showing members with the Admin role.";
    case "students":
      return "Showing members with the Student role.";
    case "candidates":
      return "Showing members with the Candidate role.";
    case "candidateIncomplete":
      return "Showing Candidates. Incomplete means a Candidate without a resume, which this member table does not show.";
    case "searchable":
      return "Showing Candidates. Searchable Candidates means a Candidate with a resume, which this member table does not show.";
    default:
      return null;
  }
}

export function readOnboardingError(error: unknown): string {
  if (typeof error === "string" && error.trim()) {
    return error;
  }
  if (error && typeof error === "object") {
    const record = error as Record<string, unknown>;
    if (typeof record.payload === "string" && record.payload.trim()) {
      return record.payload;
    }
    if (typeof record.detail === "string" && record.detail.trim()) {
      return record.detail;
    }
    if (typeof record.message === "string" && record.message.trim()) {
      return record.message;
    }
  }
  return "The onboarding update failed.";
}
